
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/opendock",
      function () {
        return require("private-next-pages/pt-br/opendock/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/opendock"])
      });
    }
  